var map = {
	"./modules/management/management.module": [
		"./src/app/modules/master/modules/management/management.module.ts",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~07c11980",
		"modules-management-management-module~modules-master-master-module~modules-receipt-receipt-module~tes~fb2e779f",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~62442341",
		"modules-management-management-module~modules-master-master-module"
	],
	"./modules/master/master.module": [
		"./src/app/modules/master/master.module.ts",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~07c11980",
		"modules-management-management-module~modules-master-master-module~modules-receipt-receipt-module~tes~fb2e779f",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~62442341",
		"modules-master-master-module~modules-patient-patient-module~modules-receipt-receipt-module",
		"modules-management-management-module~modules-master-master-module",
		"modules-master-master-module~modules-schedule-schedule-module",
		"modules-master-master-module~modules-patient-patient-module",
		"modules-master-master-module~modules-receipt-receipt-module",
		"modules-master-master-module"
	],
	"./modules/oauth/oauth.module": [
		"./src/app/modules/master/modules/oauth/oauth.module.ts",
		"modules-oauth-oauth-module"
	],
	"./modules/patient/patient.module": [
		"./src/app/modules/master/modules/patient/patient.module.ts",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~07c11980",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~62442341",
		"modules-master-master-module~modules-patient-patient-module~modules-receipt-receipt-module",
		"modules-master-master-module~modules-patient-patient-module",
		"modules-patient-patient-module"
	],
	"./modules/receipt/receipt.module": [
		"./src/app/modules/master/modules/receipt/receipt.module.ts",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~07c11980",
		"modules-management-management-module~modules-master-master-module~modules-receipt-receipt-module~tes~fb2e779f",
		"modules-master-master-module~modules-patient-patient-module~modules-receipt-receipt-module",
		"modules-master-master-module~modules-receipt-receipt-module"
	],
	"./modules/schedule/schedule.module": [
		"./src/app/modules/master/modules/schedule/schedule.module.ts",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~07c11980",
		"modules-management-management-module~modules-master-master-module~modules-patient-patient-module~mod~62442341",
		"modules-master-master-module~modules-schedule-schedule-module",
		"modules-schedule-schedule-module"
	],
	"./tessera-sanitaria/tessera-sanitaria.module": [
		"./src/app/modules/master/modules/receipt/tessera-sanitaria/tessera-sanitaria.module.ts",
		"modules-management-management-module~modules-master-master-module~modules-receipt-receipt-module~tes~fb2e779f",
		"tessera-sanitaria-tessera-sanitaria-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;